import { defineQuery, defineSystem } from "bitecs";
import { Position, Velocity, PhysicsBody } from "../components";
import type { GameWorld } from "../world";
import { clamp } from "../../utils/math";

const physicsQuery = defineQuery([Position, Velocity, PhysicsBody]);

/** Terminal velocity (blocks/sec) */
const MAX_FALL_SPEED = 78.4;

/**
 * Basic physics system — gravity and ground detection.
 * Collision with voxels handled separately (needs world data).
 */
export const physicsSystem = defineSystem((world: GameWorld) => {
  const entities = physicsQuery(world);

  for (let i = 0; i < entities.length; i++) {
    const eid = entities[i];

    // Clamp fall speed
    Velocity.y[eid] = clamp(Velocity.y[eid], -MAX_FALL_SPEED, MAX_FALL_SPEED);

    // Basic ground check (y = 0 floor, temporary until voxel collision)
    if (Position.y[eid] <= 0) {
      Position.y[eid] = 0;
      Velocity.y[eid] = 0;
      PhysicsBody.onGround[eid] = 1;
    } else {
      PhysicsBody.onGround[eid] = 0;
    }
  }

  return world;
});
